export var urlDomain = function (url) {
  var matches = url.match(/^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im);
  if (matches && matches.length === 2) {
    return matches[1];
  }
  return url;
};